import { Pencil, Mail } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';
import CustomInput from '../../../../../components/forms/CustomInput';

const SubscriptionInvoiceEmailCard = () => {
  const {
    formData,
    isEditingInvoice,
    setIsEditingInvoice,
    invoiceEmailValue,
    setInvoiceEmailValue,
    handleSaveInvoiceEmail
  } = useProfile();

  return (
    <div className="bg-white rounded-2xl sm:rounded-3xl border border-gray-100 p-4 sm:p-6 lg:p-7 shadow-sm">
      <div className="flex justify-between items-center border-b border-slate-100 pb-3.5 sm:pb-4 mb-3.5 sm:mb-4 gap-2">
        <div>
          <h2 className="font-semibold text-slate-900 text-sm sm:text-base">Invoices sent to</h2>
        </div>
        {!isEditingInvoice ? (
          <button
            onClick={() => setIsEditingInvoice(true)}
            className="px-3 sm:px-3.5 py-1.5 bg-slate-50 hover:bg-slate-100 text-slate-700 rounded-xl font-semibold text-xs border border-slate-200 hover:border-slate-300 transition-all flex items-center gap-1.5 shadow-2xs active:scale-95 cursor-pointer whitespace-nowrap"
          >
            <Pencil size={12} className="text-slate-500" />
            <span>Edit</span>
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsEditingInvoice(false)}
              className="px-2.5 sm:px-3 py-1 text-slate-500 hover:text-slate-700 text-xs font-semibold rounded-lg hover:bg-slate-100 transition-all cursor-pointer"
            >
              Cancel
            </button>
            <button
              onClick={handleSaveInvoiceEmail}
              className="px-3 sm:px-3.5 py-1 bg-[#067978] hover:bg-[#05605f] text-white text-xs font-bold rounded-lg shadow-sm shadow-[#067978]/20 transition-all active:scale-95 cursor-pointer"
            >
              Save
            </button>
          </div>
        )}
      </div>

      <div>
        {!isEditingInvoice ? (
          <div className="space-y-2 text-xs text-slate-700">
            <div className="flex flex-wrap items-center gap-2">
              <Mail size={16} className="text-[#067978] shrink-0" />
              <span className="font-medium break-all">{formData.email}</span>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-500">Registered</span>
            </div>
            {formData.invoice_email && formData.invoice_email !== formData.email && (
              <div className="flex flex-wrap items-center gap-2 pt-1">
                <Mail size={15} className="text-[#067978] shrink-0" />
                <span className="font-medium break-all">{formData.invoice_email}</span>
                <span className="rounded-full bg-teal-50 px-2 py-0.5 text-[10px] font-semibold text-[#067978]">Billing recipient</span>
              </div>
            )}
            <p className="pt-1 text-[11px] leading-4 text-slate-400">Invoices and payment receipts are sent to both addresses.</p>
          </div>
        ) : (
          <div className="space-y-2">
            <CustomInput
              type="email"
              value={invoiceEmailValue}
              onChange={(e) => setInvoiceEmailValue(e.target.value)}
              placeholder="e.g. accounts@agency.com"
              icon={Mail}
            />
            <p className="text-[11px] leading-4 text-slate-400">
              This billing address receives invoices in addition to your registered account email ({formData.email}).
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionInvoiceEmailCard;
